import React, { FC, useState } from 'react';
import { useParams } from 'react-router';

import { EvErrorCard, useSkipLinks } from '@evinced-private/ui-common';

import { useSetWebSdkBreadcrumbs } from 'src/apps/web-sdks/hooks/useSetWebSdkBreadcrumbs';
import { useShowNewIssueDetailsModal } from 'src/common/hooks/useShowNewIssueDetailsModal';
import { useWhiteBackground } from 'src/common/hooks/useWhiteBackground';
import { DASHBOARD_ERROR_MSG } from 'src/common/pages/dashboards-container/errorMessages';

import { WebSdkDetailsBlock } from '../../components/WebSdkDetailsBlock';
import { useWebSdkTestBaseDataQuery } from '../../hooks/useWebSdkTestBaseDataQuery';

import './WebSdkIssuePage.scss';

export const WebSdkIssuePage: FC = () => {
	useSkipLinks(true);
	const [error, setError] = useState(null);
	const isNewModal = useShowNewIssueDetailsModal();
	const { runId, issueId } = useParams<{ [key: string]: string }>();

	const testBaseDataQuery = useWebSdkTestBaseDataQuery(runId);

	useSetWebSdkBreadcrumbs(runId, testBaseDataQuery.data?.name, testBaseDataQuery?.data?.runTime);
	useWhiteBackground();

	return (
		// The new full page is edge-to-edge (own sticky header); only the old one and the error card use the padded card
		<div className={isNewModal && !error ? undefined : 'issue-details-page'}>
			{error ? (
				<EvErrorCard title="Error" contactUsMessage={DASHBOARD_ERROR_MSG} />
			) : (
				<WebSdkDetailsBlock
					runId={runId}
					issueId={issueId}
					isFullPageMode
					isNewModal={isNewModal}
					setError={setError}
				/>
			)}
		</div>
	);
};
